import * as location from './locationHelpers';
import * as product from './productHelpers';

const { fbq } = window;

const viewContent = () => location.isProductDrilldown && fbq('track', 'ViewContent', getPixelData());

const addToCart = pixelData => fbq('track', 'AddToCart', pixelData);

const addPaymentInfo = () => { fbq('track', 'AddPaymentInfo'); };

const initiateCheckout = pixelData => fbq('track', 'InitiateCheckout', pixelData);

const purchase = pixelData => fbq('track', 'Purchase', pixelData);

const search = pixelData => fbq('track', 'Search', pixelData);

const completeRegistration = pixelData => fbq('track', 'CompleteRegistration', pixelData);

const defaultPixelData = {
  currency: window.request.currency || 'USD',
  referrer: document.referrer,
  userAgent: navigator.userAgent,
  language: navigator.language,
  content_type: 'product',
};

const getPixelData = (customData = {}) => {
  const defaults = {
    content_name: product.getTitle(),
    content_ids: product.getSKU(),
    value: product.getPrice(),
  };

  return Object.assign(defaultPixelData, defaults, customData);
};

export {
  addPaymentInfo,
  addToCart,
  viewContent,
  initiateCheckout,
  purchase,
  search,
  completeRegistration,
  defaultPixelData,
  getPixelData,
};
